import AdminSidebar from "../../../components/AdminSidebar";
import ReservedStock from "../Devices/ReservedStock";

const SoldStockReport = () => {
  return <ReservedStock />;
};

export default SoldStockReport;
